export default __webpack_public_path__ + "static/media/login.cb3a30d8.svg";